/** A frase que o servidor devolveu na recusa; na falta dela, a frase que a tela já tinha. */
export function serverMessage(error: unknown, fallback: string): string {
  const message = (error as { response?: { data?: { error?: unknown } } })?.response?.data?.error;
  return typeof message === 'string' && message ? message : fallback;
}
